const profileInitialValues = {

    id: "",

    userName: "",

    gender: true,

    birthDate: "",

    registerDate: "",

    expireDate: "",

    lastLoginDate: "",

    imageUrl: "",

};

export default profileInitialValues;